// import { TreeData, DialogData } from './../../service/tree-data.model';
import {Component, EventEmitter, Inject, Input, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ICategoryTreeNode, IEditDialogData} from "../tree-service/tree-data.model";
import {TranslocoService} from "@ngneat/transloco";
import * as _ from "lodash";


@Component({
    selector: 'app-add-node',
    templateUrl: './add-node.component.html',
    styleUrls: ['./add-node.component.css']
})
export class AddNodeComponent {
    @Input() isTop: boolean;
    @Input() currentNode: ICategoryTreeNode;
    @Output() addedNode = new EventEmitter();
    name: string;

    constructor(public dialog: MatDialog) {
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(NewNodeDialog, {
            width: '250px',
            data: {Component: 'Add'}
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                const node: ICategoryTreeNode = {
                    Id: _.uniqueId(""),
                    Name: result.nodeName,
                    Children: []
                };
                if (this.isTop) {
                    this.addedNode.emit(node);
                } else {
                    this.addedNode.emit({currentNode: this.currentNode, node});
                }
            }
        });
    }
}

@Component({
    selector: 'app-new-node',
    templateUrl: '../node-dialog/node-dialog.html',
})
// tslint:disable-next-line
export class NewNodeDialog {
    name;

    constructor(public dialogRef: MatDialogRef<NewNodeDialog>, @Inject(MAT_DIALOG_DATA) public data: IEditDialogData, private translocoService: TranslocoService) {
        // this.name = data.Name;
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onAdd(): void {
        if (this.name) {
            this.dialogRef.close({
                nodeName: this.name
            });
        }
    }
}
